/* ToyDrop packaging upgrade: the cart drawer's picker (snippets/td-packaging.liquid).

   One POST to /cart/update.js per choice, keyed by variant id, so choosing a
   tier sets that variant to 1 and the other to 0 in the same request: there is
   never a moment with two packaging lines, and Minimum is simply both at 0.
   The response carries the re-rendered drawer (Section Rendering API), which
   replaces .drawer__inner exactly as Dawn's own cart-drawer-items does, so the
   totals, the free-delivery bar and the new packaging line all update from the
   server's cart rather than from anything guessed here.

   Liquid hands over data-fix when the cart breaks an invariant (two packaging
   lines, a quantity above 1, or a packaging line with nothing else in the
   cart). The element sends it as soon as it connects, and because every cart
   change re-renders the drawer, this runs after every change from anywhere:
   the stepper, the remove button, a product page add. */
(function () {
  if (customElements.get('td-packaging')) return;

  var busy = false;
  var queued = null;
  /* A cart the server will not correct must not loop: two tries a page. */
  var fixesLeft = 2;

  function sectionHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function render(state, hadFocus) {
    var sections = state.sections || {};
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner && sections['cart-drawer']) {
      var html = sectionHTML(sections['cart-drawer'], '.drawer__inner');
      if (html !== null) inner.innerHTML = html;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var bubbleHTML = sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);

    /* The cart page renders its own lines; it is rarely used with the drawer
       on, so it simply reloads rather than duplicating its section wiring. */
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }

    /* innerHTML dropped the focused radio; put focus back on the new one so a
       keyboard user is not thrown to the top of the document mid-choice. */
    if (hadFocus && drawer && drawer.classList.contains('active')) {
      var next = document.querySelector('#CartDrawer .td-pack-input:checked');
      if (next) {
        next.focus();
      } else if (state.item_count === 0 && typeof trapFocus === 'function') {
        var empty = drawer.querySelector('.drawer__inner-empty');
        if (empty) trapFocus(empty, empty.querySelector('a'));
      }
    }

    /* 'cart-items' as the source: the drawer's own lines already re-rendered
       above, and that source is what stops them fetching the same HTML again.
       The header bubble pop in toydrop.js still hears it. */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
    }
  }

  function send(updates, hadFocus) {
    if (busy) {
      queued = { updates: updates, hadFocus: hadFocus };
      return;
    }
    busy = true;
    var host = document.querySelector('#CartDrawer td-packaging');
    if (host) host.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || body.status) throw new Error(body.description || body.message || 'cart update failed');
          return body;
        });
      })
      .then(function (state) {
        render(state, hadFocus);
      })
      .catch(function (error) {
        console.error('[td-packaging]', error);
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        var stale = document.querySelector('#CartDrawer td-packaging');
        if (stale) stale.removeAttribute('aria-busy');
      })
      .finally(function () {
        busy = false;
        if (queued) {
          var next = queued;
          queued = null;
          send(next.updates, next.hadFocus);
        }
      });
  }

  class TdPackaging extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange);
      var fix = this.dataset.fix;
      if (fix && fixesLeft > 0) {
        fixesLeft -= 1;
        try {
          send(JSON.parse(fix), false);
        } catch (e) {
          console.error('[td-packaging] bad data-fix', e);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      clearTimeout(this.timer);
    }

    onChange(event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('td-pack-input')) return;
      /* cart-drawer-items listens for 'change' to validate quantity steppers,
         and would read this radio as a malformed quantity input. */
      event.stopPropagation();

      this.querySelectorAll('.td-pack-desc').forEach(function (p) {
        p.hidden = p.dataset.for !== input.dataset.key;
      });

      var updates = {};
      if (this.dataset.premium) updates[this.dataset.premium] = input.value === this.dataset.premium ? 1 : 0;
      if (this.dataset.ultra) updates[this.dataset.ultra] = input.value === this.dataset.ultra ? 1 : 0;

      /* Arrow keys move through a radio group one change event at a time;
         wait for the choice to settle rather than posting every card passed. */
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        send(updates, true);
      }, 250);
    }
  }

  customElements.define('td-packaging', TdPackaging);
})();
